import { initRemoteLogger } from '../../artemis/src/sdk';
import { bootstrap, registerDI } from './app-init';

declare const ARTEMIS_API_KEY: string;
declare const REMOTE_LOG_ENDPOINT: string;

// Initialize the remote log server for local dev (proxied) and deployed dev/staging builds
// (direct Cloud Run URL via REMOTE_LOG_ENDPOINT).
const logEndpoint = REMOTE_LOG_ENDPOINT || (import.meta.env.DEV ? '/api/log' : '');
if (logEndpoint) {
    // Detect environment from hostname to match LoggingService's env tagging
    const { hostname } = window.location;
    let env = 'local';
    if (hostname.includes('.stg.') || hostname.includes('-staging.')) {
        env = 'staging';
    } else if (hostname.includes('.dev.') || hostname.includes('-development.')) {
        env = 'dev';
    }

    initRemoteLogger({
        service: 'tm-ux-backoffice-v2',
        env,
        endpoint: logEndpoint,
        apiKey: ARTEMIS_API_KEY,
    });
}

registerDI().then(di => bootstrap(di));
